import _ from 'lodash';
import React, { useContext, useEffect, useRef, useState } from 'react';

const OpidNavigatorContext = React.createContext({goto: (path)=>{}});

export default OpidNavigatorContext;

export const useOpidNavigator = ()=>{
    const navigation = useContext(OpidNavigatorContext);

    return navigation;
}



export const OpidNavigatorThing = ({setter, children}) => {
    const navigation = { goto: (path)=>{ 
        if (window && window.history && window.history.pushState){
            window.history.pushState({}, null, path);
        }
        setter(path);
    } };

    return <OpidNavigatorContext.Provider value={navigation}>
        {children}
    </OpidNavigatorContext.Provider>
}